/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Rooster_TitleInputs */

const nl_planning_rooster_title = /** @type {(inputs: Planning_Rooster_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rooster`)
};

/**

* @param {Planning_Rooster_TitleInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_rooster_title = /** @type {((inputs?: Planning_Rooster_TitleInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Rooster_TitleInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_rooster_title(inputs)
});
export { planning_rooster_title as "planning.rooster.title" }